<template>
    <div class="explanation-container">
        <div>
            <h3 class="text-h5 mb-3 text-left">Customer Confirmation</h3>

            <p class="explanation-text mb-3">
                {{ order_data.customer_nickname }} clicks the link in the text message and lands on a webpage with
                her order details, asking her to confirm them. Let's first consider the scenario where all of the
                information is already correct.
            </p>

            <div class="explanation-points">
                <div
                    class="explanation-point"
                    v-for="(point, idx) in explanationPoints"
                    :key="idx"
                >
                    <v-icon
                        color="primary"
                        size="28"
                        class="point-icon"
                        aria-hidden="true"
                    >
                        mdi-chevron-right
                    </v-icon>
                    <p class="point-text">{{ point }}</p>
                </div>
            </div>
        </div>

        <div class="primary-note">
            <v-icon
                color="info"
                size="20"
                aria-hidden="true"
                left
            >
                mdi-information
            </v-icon>
            <span>
                In this scenario, written consent will be captured because the "I give Barrel Creek Vineyards permission
                ..." checkbox is selected. If the user leaves this checkbox unchecked, consent is not given nor
                recorded, and the rest of this demo would not apply.
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        order_data: {
            type: Object,
            required: true
        }
    },

    computed: {
        explanationPoints() {
            const nickname = this.order_data?.customer_nickname || 'The customer';
            return [
                `${nickname} scrolls to the bottom and selects the "Check All" button, confirming that all information is correct`,
                `She then clicks the "Confirm Details" button`
            ];
        }
    }
}
</script>

<style lang="scss" scoped>
.explanation-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1.5rem;
    align-items: center;
    padding: 2rem;

    @media (max-width: 900px) {
        padding: .5rem 0;
        gap: 1rem;
    }
}
</style>
